/**
 * @generated SignedSource<<ec0d688e3c24f8961ad0d262cd87bf35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProgramTemplatesList_connection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"CardProgramTemplate_template">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "ProgramTemplatesList_connection";
};
export type ProgramTemplatesList_connection$key = {
  readonly " $data"?: ProgramTemplatesList_connection$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProgramTemplatesList_connection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProgramTemplatesList_connection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProgramTemplateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProgramTemplate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CardProgramTemplate_template"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProgramTemplateConnection",
  "abstractKey": null
};

(node as any).hash = "238bb495283d385afe067ccbd6bdadee";

export default node;
